import { Availability } from './Availability';
import { Image } from './Image';
import { Metadata } from './Metadata';

export class Product {
    id: number;
    chainproductid: number;
    name: string;
    description: string;
    cost: number;
    basecalories: string | null;
    maxcalories: string | null;
    caloriesseparator: string | null;
    displayid: number | null;
    starthour: number;
    endhour: number;
    source: string;
    imagefilename: string | null;
    maximumquantity: string | null;
    minimumquantity: string | null;
    maximumbasketquantity: string | null;
    minimumbasketquantity: string | null;
    quantityincrement: string | null;
    shortdescription: string;
    metadata: Array<Metadata> | null;
    alcoholstatus: string;
    images: null | Array<Image>;
    availability: Availability;
    unavailablehandoffmodes: Array<string>;

    constructor(init?: Partial<Product>) {
        Object.assign(this, init);
    }
}
